import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Small inline SVG marks used in the pricing table: a check for
 * "included" and a dash for "not included". Lightweight — no external
 * icon library. Colours follow currentColor so the caller tints via
 * inline style.
 */
export function CheckMark() {
    return (_jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", "aria-hidden": "true", style: { display: 'block' }, children: _jsx("path", { d: "M3.5 8.5l3 3 6-7", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
export function DashMark() {
    return (_jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", "aria-hidden": "true", style: { display: 'block' }, children: _jsx("path", { d: "M5 8h6", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }) }));
}
//# sourceMappingURL=icons.js.map